module.exports = __webpack_public_path__ + "public/img/logo_unmer_192.7bdbfb92.png";